export default "__VITE_ASSET__C449zdrB__"